import Image from 'next/image'
import React from 'react'

type TagButtonProps = {
  onClick?: () => void
  text: string
  color?: string
  textColor?: string
  hoverArrow?: boolean
}
const TagButton = ({
  text,
  color,
  onClick,
  textColor,
  hoverArrow = false,
}: TagButtonProps) => {
  return (
    <button
      onClick={onClick}
      className=' uppercase md:py-[9px] sm:py-[8px] py-[7px] lg:py-[11px] ps-[8px] pe-[15px] rounded-full border border-[#A08260] flex justify-center items-center group'
      style={{ color: textColor || color, borderColor: color }}
    >
      <div className=' h-5 w-5  items-center justify-center flex'>
        <div
          className='h-1 w-1 rounded-full bg-white group-hover:w-5 group-hover:h-5 duration-300 ease-in-out justify-center items-center flex  group-hover:opacity-100 group-hover:translate-x-1'
          style={{ backgroundColor: hoverArrow ? 'transparent' : color }}
        >
          <Image
            height={100}
            width={100}
            src='/ic_right_arrow_rgb.svg'
            className='w-full object-cover p-1 -translate-x-5 opacity-0 group-hover:opacity-100 group-hover:translate-x-0 duration-300 delay-75'
            alt=''
          />
        </div>
      </div>
      <h1 className=' font-barlowSemibold tracking-widest ps-2 text-[11px] mb-sm:text-[12.5px] mb-md:text-[13.5px] mb-lg:text-[15px] lg:text-[16px]'>
        {text}
      </h1>
    </button>
  )
}

export default TagButton
